(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ChannelConfTestMessageDialogController', ChannelConfTestMessageDialogController);

    ChannelConfTestMessageDialogController.$inject = ['$uibModalInstance', 'channelConfId', 'ChannelConf'];

    function ChannelConfTestMessageDialogController($uibModalInstance, channelConfId, ChannelConf) {
        var vm = this;

        vm.channelConf = {};
        vm.form = {
            recipient: null,
            subject: null,
            messageText: null,
            messageHtml: null
        };

        vm.sending = false;
        vm.result = null;

        vm.clear = clear;
        vm.send = send;

        loadChannelConf(channelConfId);

        function loadChannelConf(id) {
            ChannelConf.get({id: id}, function(res) {
                vm.channelConf = res;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function send() {
            vm.result = null;

            if (!vm.form.recipient ) {
                return; // show-validation fera le job
            }

            vm.sending = true;

            ChannelConf.testMessage({
                channelConfId: channelConfId,
                recipient: vm.form.recipient,
                subject: vm.form.subject,
                messageText: vm.form.messageText,
                messageHtml: vm.form.messageHtml
            }, function(res) {
                vm.result = res;
                vm.sending = false;
            }, function(err) {
                vm.result = {
                    success: false,
                    message: (err && err.data && err.data.message) ? err.data.message : 'Erreur lors de l’envoi'
                };
                vm.sending = false;
            });
        }
    }
})();
